import React from 'react';
import ReactDOM from 'react-dom';
import { Point } from '../coreTypes';
import { clamp, equal } from '../coreUtils';

export interface IFixedPosDivProps {
  pos?: Point;
}

export class FixedPosDiv extends React.Component<IFixedPosDivProps & React.HTMLAttributes<HTMLDivElement>> {
  private div: HTMLDivElement;
  private childExtent = { x: 0, y: 0 };

  constructor(props: IFixedPosDivProps & React.HTMLAttributes<HTMLDivElement>) {
    super(props);

    this.div = document.createElement('div');
    this.div.style.position = 'fixed';
  }

  componentDidMount = () => {
    document.getElementById('App')?.appendChild(this.div);
  }

  componentDidUpdate = () => {
    if(!this.div.parentElement)
      document.getElementById('App')?.appendChild(this.div);
    
    const rect = this.div.getBoundingClientRect();
    const extent = { x: rect.width, y: rect.height };
    if (!equal(extent, this.childExtent)) {
      this.childExtent = extent;
      this.forceUpdate();
    }
  };
  componentWillUnmount = () => {
    this.div.parentElement?.removeChild(this.div);
  }

  public render() {
    const { pos, ...restProps } = this.props;

    const maxX = window.innerWidth - this.childExtent.x;
    const maxY = window.innerHeight - this.childExtent.y;
    this.div.style.left = `${clamp(pos?.x || 0, 0, maxX)}px`;
    this.div.style.top = `${clamp(pos?.y || 0, 0, maxY)}px`;

    return ReactDOM.createPortal(
      <div {...restProps}>
        {this.props.children}
      </div>,
      this.div
    );
  }
}
